import { render, staticRenderFns } from "./RevokeModalDeadline.vue?vue&type=template&id=6acde2b0"
import script from "./RevokeModalDeadline.vue?vue&type=script&lang=js"
export * from "./RevokeModalDeadline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports